import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const createApp = () => ReactDOM.render(
    <App />,
  document.getElementById('root')
);

createApp();

//@ts-ignore
if (module.hot) {
  //@ts-ignore
  module.hot.accept('./App', () => createApp());
}
